import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private axios,
    ) { }

  public getAccountDetail = (id) => new Promise(async (resolve, reject) => {
    this.axios.get(`/account/${id}`)
      .then(res => {
        resolve(res.data);
      }).catch((error) => {
        reject({
          error: true,
          message: error
        });
      });
  })


  public getPayment = (account_id = 0) => new Promise(async (resolve, reject) => {
    this.axios.get(`/payment/${account_id}`)
      .then(res => {
        resolve(res.data);
      }).catch((error) => {
        reject({
          error: true,
          message: error
        });
      });
  })

  public makePayment = (body: object) => new Promise(async (resolve, reject) => {
    this.axios.post(`/makePayment`,  body)
      .then(res => {
        resolve(res.data);
      }).catch((error) => {
        reject({
          error: true,
          message: error
        });
      });
  })

}
